export const exposeFoxtailAccessToken = (token: string) => {
    window.localStorage.setItem('foxtail_access_token', token)
}

export const clearFoxtailAccessToken = () => {
    window.localStorage.removeItem('foxtail_access_token')
}
